import React from 'react'
import classNames from 'classnames'
import { TextCircleIcon } from '@/atoms/Icons/TextCircleIcon'
import { VideoCircleIcon } from '@/atoms/Icons/VideoCircleIcon'
import { GetMomentOwnersQuery } from '@/types/codegen-federation'

export type Story = NonNullable<NonNullable<NonNullable<GetMomentOwnersQuery['moment']>['owners']>[number]>['story']
export type StoryType = 'text' | 'video' | undefined

interface MomentOwnershipAvatarProps {
  index: number
  name?: string
  isActor?: boolean
  imageUrl?: string
  className?: string
  iconPosition: 'right' | 'left' | 'none'
  storyType?: StoryType
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

export const MomentOwnershipAvatar: React.FC<MomentOwnershipAvatarProps> = React.memo(
  ({ index, name, isActor, imageUrl, className, iconPosition, storyType, onClick }) => {
    const backgroundImage = imageUrl ? `url(${imageUrl})` : undefined

    return (
      <div className={classNames('relative', { 'cursor-pointer': !!onClick })} onClick={onClick}>
        <div
          className={classNames(
            isActor ? 'border ring-black ring-offset-copper ring-offset-2 ring-1' : 'ring-2 ring-black',
            'h-12 w-12 rounded-full border-black overflow-hidden bg-cover shrink-0 grow-0',
            className,
            {
              '-ml-3': index > 0,
              'sm:hidden xl:block': index > 4 && index < 6,
              'sm:hidden 2xl:block': index > 5 && index < 7,
              hidden: index > 5,
            },
          )}
          style={{ backgroundImage }}
          title={name}
        />
        {storyType && (
          <div
            className={classNames('absolute top-0', {
              '-right-[1px]': iconPosition === 'right',
              '-left-[11px]': iconPosition === 'left' && index > 0,
              '-left-[1px]': iconPosition === 'left' && index === 0,
              'sm:hidden xl:block': index > 4 && index < 6,
              'sm:hidden 2xl:block': index > 5 && index < 7,
              hidden: index > 5,
            })}
          >
            {storyType === 'text' && <TextCircleIcon size={16} />}
            {storyType === 'video' && <VideoCircleIcon size={16} />}
          </div>
        )}
      </div>
    )
  },
)

MomentOwnershipAvatar.displayName = 'React.memo(MomentOwnershipAvatar)'
